export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: 'kr' | 'jp' | 'cn' | 'other';
  tags: string[];
  rating: number;
  description: string;
  status: '连载中' | '已完结';
  updateTime: string;
  totalChapters: number;
  isHot: boolean;
  isNew: boolean;
  chapters: Chapter[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updateTime: string;
}

export const categories = [
  { key: 'all', label: '全部', icon: 'ri-apps-2-line' },
  { key: 'kr', label: '韩漫', icon: 'ri-kakao-talk-line' },
  { key: 'jp', label: '日漫', icon: 'ri-sun-line' },
  { key: 'cn', label: '国漫', icon: 'ri-china-railway-line' },
  { key: 'other', label: '其他', icon: 'ri-global-line' },
];

export const categoryLabels: Record<string, string> = {
  all: '全部漫画',
  kr: '皮皮漫画韩漫',
  jp: '皮皮漫画日漫',
  cn: '皮皮漫画国漫',
  other: '皮皮漫画其他类型',
};

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '霸道总裁的契约新娘',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20style%2C%20a%20handsome%20CEO%20in%20a%20dark%20suit%20with%20a%20mysterious%20expression%2C%20elegant%20female%20lead%20in%20a%20flowing%20dress%2C%20soft%20dramatic%20lighting%20with%20cherry%20blossom%20petals%20falling%2C%20romantic%20mood%2C%20clean%20illustration%20style%20on%20a%20neutral%20warm%20gradient%20background&width=400&height=560&seq=pipi-comic-001&orientation=portrait',
    category: 'kr',
    tags: ['恋爱', '都市', '霸总'],
    rating: 9.2,
    description: '她是落魄家族的千金，为了拯救家族企业，不得不与冷酷无情的商业帝王签订契约婚姻。原本以为只是一场交易，却在不经意间擦出了爱的火花。当她以为自己可以全身而退时，却发现早已深陷其中无法自拔……',
    status: '连载中',
    updateTime: '2026-08-04',
    totalChapters: 87,
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-001-87', title: '第87话 无法说出口的真心', number: 87, updateTime: '2026-08-04' },
      { id: 'ch-001-86', title: '第86话 深夜的告白', number: 86, updateTime: '2026-07-28' },
      { id: 'ch-001-85', title: '第85话 误会解除', number: 85, updateTime: '2026-07-21' },
      { id: 'ch-001-84', title: '第84话 危机降临', number: 84, updateTime: '2026-07-14' },
      { id: 'ch-001-83', title: '第83话 他的温柔', number: 83, updateTime: '2026-07-07' },
    ],
  },
  {
    id: 'comic-002',
    title: '转生成为史莱姆的那件事',
    author: '伏濑',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20fantasy%20isekai%20manga%20cover%20style%2C%20a%20cute%20blue%20slime%20character%20with%20magical%20aura%2C%20adventurers%20in%20a%20fantasy%20world%20background%20with%20castle%20and%20dragon%2C%20vibrant%20colors%2C%20action%20and%20adventure%20theme%2C%20clean%20anime%20illustration%20on%20warm%20neutral%20backdrop&width=400&height=560&seq=pipi-comic-002&orientation=portrait',
    category: 'jp',
    tags: ['奇幻', '冒险', '异世界'],
    rating: 9.5,
    description: '普通的37岁上班族三上悟，在某天被随机杀人魔刺杀身亡后，竟然转生到了异世界成为了一只史莱姆！在新的世界中，他获得了各种特殊能力，结识了众多伙伴，开始了征服世界的冒险之旅……',
    status: '连载中',
    updateTime: '2026-08-03',
    totalChapters: 124,
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-002-124', title: '第124话 魔王们的宴会', number: 124, updateTime: '2026-08-03' },
      { id: 'ch-002-123', title: '第123话 新的同盟', number: 123, updateTime: '2026-07-27' },
      { id: 'ch-002-122', title: '第122话 决战前夜', number: 122, updateTime: '2026-07-20' },
      { id: 'ch-002-121', title: '第121话 力量的觉醒', number: 121, updateTime: '2026-07-13' },
      { id: 'ch-002-120', title: '第120话 迷宫最深部', number: 120, updateTime: '2026-07-06' },
    ],
  },
  {
    id: 'comic-003',
    title: '斗罗大陆',
    author: '唐家三少',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20fantasy%20manhua%20cover%2C%20a%20young%20warrior%20with%20spirit%20rings%20and%20glowing%20martial%20aura%2C%20epic%20mountainous%20landscape%20background%20with%20ancient%20temples%2C%20dynamic%20action%20pose%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20clean%20illustration%20on%20neutral%20backdrop&width=400&height=560&seq=pipi-comic-003&orientation=portrait',
    category: 'cn',
    tags: ['玄幻', '热血', '战斗'],
    rating: 9.7,
    description: '唐门外门弟子唐三，因偷学内门绝学被逼跳崖明志，却意外来到了另一个世界——斗罗大陆。在这里，每个人在六岁时都会觉醒自己的武魂，唐三的武魂是蓝银草，被认为是最没用的废武魂。但他凭借唐门的绝学，一步步走向了大陆巅峰……',
    status: '连载中',
    updateTime: '2026-08-04',
    totalChapters: 356,
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-003-356', title: '第356话 海神九考', number: 356, updateTime: '2026-08-04' },
      { id: 'ch-003-355', title: '第355话 天使之神的降临', number: 355, updateTime: '2026-07-28' },
      { id: 'ch-003-354', title: '第354话 最终的对决', number: 354, updateTime: '2026-07-21' },
      { id: 'ch-003-353', title: '第353话 伙伴的信念', number: 353, updateTime: '2026-07-14' },
      { id: 'ch-003-352', title: '第352话 封号斗罗之战', number: 352, updateTime: '2026-07-07' },
    ],
  },
  {
    id: 'comic-004',
    title: '女神降临',
    author: '猫咪',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20beauty%20and%20romance%20manhwa%20cover%2C%20a%20pretty%20girl%20transforming%20from%20plain%20to%20stunning%20with%20makeup%2C%20split%20mirror%20concept%20showing%20two%20sides%2C%20school%20setting%20background%20with%20soft%20lighting%2C%20modern%20fashion%20style%2C%20clean%20illustration%20on%20warm%20neutral%20backdrop&width=400&height=560&seq=pipi-comic-004&orientation=portrait',
    category: 'kr',
    tags: ['校园', '恋爱', '美妆'],
    rating: 9.0,
    description: '因为外表而自卑的女孩任朱静，通过化妆技术华丽变身为校园女神。当她以为可以隐藏真实面目开始新生活时，却遇到了唯一知道她素颜真面目的学霸男生李修豪。一场关于颜值与真心的校园恋爱故事就此展开……',
    status: '已完结',
    updateTime: '2026-06-15',
    totalChapters: 210,
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-004-210', title: '第210话 永远的约定（最终话）', number: 210, updateTime: '2026-06-15' },
      { id: 'ch-004-209', title: '第209话 最美的告白', number: 209, updateTime: '2026-06-08' },
      { id: 'ch-004-208', title: '第208话 幸福的结局', number: 208, updateTime: '2026-06-01' },
      { id: 'ch-004-207', title: '第207话 最后的考验', number: 207, updateTime: '2026-05-25' },
      { id: 'ch-004-206', title: '第206话 真心话大冒险', number: 206, updateTime: '2026-05-18' },
    ],
  },
  {
    id: 'comic-005',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20demon%20slayer%20manga%20cover%20style%2C%20a%20young%20swordsman%20with%20a%20nichirin%20blade%20and%20green%20checkered%20haori%2C%20dark%20atmospheric%20background%20with%20full%20moon%20and%20cherry%20blossoms%2C%20water%20breathing%20effect%2C%20action%20and%20dramatic%20lighting%2C%20clean%20anime%20illustration&width=400&height=560&seq=pipi-comic-005&orientation=portrait',
    category: 'jp',
    tags: ['热血', '战斗', '少年'],
    rating: 9.8,
    description: '大正时代的日本，少年灶门炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹变回人类的方法，炭治郎踏上了成为鬼杀队剑士的道路，与各种强大的鬼展开了殊死搏斗……',
    status: '已完结',
    updateTime: '2026-05-20',
    totalChapters: 205,
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch-005-205', title: '第205话 生命的循环（最终话）', number: 205, updateTime: '2026-05-20' },
      { id: 'ch-005-204', title: '第204话 决战终结', number: 204, updateTime: '2026-05-13' },
      { id: 'ch-005-203', title: '第203话 最后的呼吸', number: 203, updateTime: '2026-05-06' },
      { id: 'ch-005-202', title: '第202话 柱的觉悟', number: 202, updateTime: '2026-04-29' },
      { id: 'ch-005-201', title: '第201话 日之呼吸', number: 201, updateTime: '2026-04-22' },
    ],
  },
  {
    id: 'comic-006',
    title: '全职高手',
    author: '蝴蝶蓝',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20esports%20gaming%20manhua%20cover%2C%20a%20cool%20male%20gamer%20in%20a%20hoodie%20holding%20a%20gaming%20mouse%2C%20virtual%20reality%20game%20world%20effect%20in%20background%2C%20cyberpunk%20aesthetic%20with%20warm%20orange%20and%20golden%20accents%2C%20competitive%20esports%20atmosphere%2C%20clean%20illustration&width=400&height=560&seq=pipi-comic-006&orientation=portrait',
    category: 'cn',
    tags: ['游戏', '竞技', '热血'],
    rating: 9.6,
    description: '荣耀职业联赛的顶尖选手叶修，因为种种原因被俱乐部驱逐。离开职业圈的他栖身于一家网吧成了网管，但他却带着十年的游戏经验和一把自制武器千机伞，在荣耀新开的第十区重新投入了游戏，开始了重返巅峰之路……',
    status: '连载中',
    updateTime: '2026-08-02',
    totalChapters: 188,
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'ch-006-188', title: '第188话 王者归来', number: 188, updateTime: '2026-08-02' },
      { id: 'ch-006-187', title: '第187话 总决赛开幕', number: 187, updateTime: '2026-07-26' },
      { id: 'ch-006-186', title: '第186话 团队战', number: 186, updateTime: '2026-07-19' },
      { id: 'ch-006-185', title: '第185话 战术布局', number: 185, updateTime: '2026-07-12' },
      { id: 'ch-006-184', title: '第184话 半决赛', number: 184, updateTime: '2026-07-05' },
    ],
  },
  {
    id: 'comic-007',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20fantasy%20manhwa%20cover%2C%20a%20powerful%20dark%20haired%20hunter%20with%20glowing%20blue%20eyes%20and%20shadow%20soldiers%20behind%20him%2C%20dungeon%20portal%20background%20with%20monsters%2C%20dark%20and%20epic%20atmosphere%2C%20clean%20illustration%20on%20neutral%20warm%20backdrop&width=400&height=560&seq=pipi-comic-007&orientation=portrait',
    category: 'kr',
    tags: ['奇幻', '战斗', '升级'],
    rating: 9.9,
    description: '在被称为"猎人"的人们觉醒超能力的世界中，最弱E级猎人成振宇在一次几乎团灭的双重地下城任务中，意外获得了"系统"的独特升级能力。从此，他开始了从最弱到最强的传奇逆袭之路……',
    status: '已完结',
    updateTime: '2026-04-30',
    totalChapters: 179,
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-007-179', title: '第179话 新的开始（最终话）', number: 179, updateTime: '2026-04-30' },
      { id: 'ch-007-178', title: '第178话 最终决战', number: 178, updateTime: '2026-04-23' },
      { id: 'ch-007-177', title: '第177话 君主降临', number: 177, updateTime: '2026-04-16' },
      { id: 'ch-007-176', title: '第176话 影之军团', number: 176, updateTime: '2026-04-09' },
      { id: 'ch-007-175', title: '第175话 觉醒之力', number: 175, updateTime: '2026-04-02' },
    ],
  },
  {
    id: 'comic-008',
    title: '咒术回战',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20supernatural%20action%20manga%20cover%2C%20a%20teenage%20boy%20with%20spiky%20pink%20hair%20and%20dark%20tattoo%20marks%2C%20cursed%20energy%20visual%20effects%20in%20purple%20and%20red%2C%20urban%20Tokyo%20background%2C%20dynamic%20fighting%20pose%2C%20clean%20anime%20illustration%20style&width=400&height=560&seq=pipi-comic-008&orientation=portrait',
    category: 'jp',
    tags: ['战斗', '校园', '咒术'],
    rating: 9.4,
    description: '高中生虎杖悠仁拥有超出常人的身体能力，某天他为了解救被"咒物"袭击的学长学姐，吞下了宿傩的手指，成为了两面宿傩的容器。从此，他被卷入到了咒术师与诅咒之间的战斗中……',
    status: '连载中',
    updateTime: '2026-08-01',
    totalChapters: 248,
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-008-248', title: '第248话 死灭回游终局', number: 248, updateTime: '2026-08-01' },
      { id: 'ch-008-247', title: '第247话 宿傩的完全体', number: 247, updateTime: '2026-07-25' },
      { id: 'ch-008-246', title: '第246话 五条觉醒', number: 246, updateTime: '2026-07-18' },
      { id: 'ch-008-245', title: '第245话 领域展开', number: 245, updateTime: '2026-07-11' },
      { id: 'ch-008-244', title: '第244话 最终决战', number: 244, updateTime: '2026-07-04' },
    ],
  },
  {
    id: 'comic-009',
    title: '仙王的日常生活',
    author: '枯玄',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20cultivation%20manhua%20cover%2C%20a%20laid-back%20young%20immortal%20in%20modern%20school%20uniform%20with%20divine%20glowing%20aura%2C%20mixing%20ancient%20cultivation%20and%20modern%20school%20life%2C%20humorous%20and%20relaxed%20atmosphere%2C%20clean%20illustration%20on%20warm%20backdrop&width=400&height=560&seq=pipi-comic-009&orientation=portrait',
    category: 'cn',
    tags: ['搞笑', '修仙', '校园'],
    rating: 8.9,
    description: '六岁就无敌于修真界的仙王王令，为了体验平凡的生活，隐藏身份进入了一所普通的修真高中。然而，即便他尽力低调，各种麻烦和奇遇还是纷至沓来。史上最强的修真高中生，开始了他的"平凡"日常生活……',
    status: '连载中',
    updateTime: '2026-08-03',
    totalChapters: 312,
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch-009-312', title: '第312话 仙王的烦恼', number: 312, updateTime: '2026-08-03' },
      { id: 'ch-009-311', title: '第311话 不速之客', number: 311, updateTime: '2026-07-27' },
      { id: 'ch-009-310', title: '第310话 校园祭', number: 310, updateTime: '2026-07-20' },
      { id: 'ch-009-309', title: '第309话 隐藏的实力', number: 309, updateTime: '2026-07-13' },
      { id: 'ch-009-308', title: '第308话 试炼开始', number: 308, updateTime: '2026-07-06' },
    ],
  },
  {
    id: 'comic-010',
    title: '某天成为公主',
    author: 'Spoon / Plutus',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20romance%20manhwa%20cover%2C%20a%20beautiful%20princess%20in%20a%20magnificent%20royal%20gown%20with%20long%20blonde%20hair%2C%20palace%20interior%20background%20with%20golden%20accents%2C%20regal%20and%20elegant%20atmosphere%2C%20soft%20warm%20lighting%2C%20clean%20illustration&width=400&height=560&seq=pipi-comic-010&orientation=portrait',
    category: 'kr',
    tags: ['奇幻', '恋爱', '穿越'],
    rating: 9.3,
    description: '一觉醒来发现自己变成了小说中的公主——而且还是那个注定要被亲生父亲杀死的悲剧公主阿塔纳西娅。为了改变命运，她决定在父皇面前努力刷存在感。然而，这个冷血皇帝父亲似乎并没有想象中那么冷酷……',
    status: '已完结',
    updateTime: '2026-03-28',
    totalChapters: 125,
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch-010-125', title: '第125话 幸福的光芒（最终话）', number: 125, updateTime: '2026-03-28' },
      { id: 'ch-010-124', title: '第124话 父亲的选择', number: 124, updateTime: '2026-03-21' },
      { id: 'ch-010-123', title: '第123话 真相大白', number: 123, updateTime: '2026-03-14' },
      { id: 'ch-010-122', title: '第122话 危机时刻', number: 122, updateTime: '2026-03-07' },
      { id: 'ch-010-121', title: '第121话 舞会之夜', number: 121, updateTime: '2026-02-28' },
    ],
  },
  {
    id: 'comic-011',
    title: '海贼王',
    author: '尾田荣一郎',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20pirate%20adventure%20manga%20cover%20style%2C%20a%20young%20pirate%20with%20straw%20hat%20and%20big%20smile%2C%20pirate%20ship%20on%20ocean%20with%20sunset%20sky%2C%20treasure%20map%20elements%2C%20adventure%20and%20friendship%20theme%2C%20clean%20anime%20illustration%20on%20warm%20neutral%20backdrop&width=400&height=560&seq=pipi-comic-011&orientation=portrait',
    category: 'jp',
    tags: ['冒险', '热血', '少年'],
    rating: 9.9,
    description: '拥有财富、名声、权力，这世界上的一切的男人——海贼王哥尔·D·罗杰，在被行刑受死之前说了一句话："想要我的财宝吗？想要的话可以全部给你，去找吧！我把所有财宝都放在那里。"世界迎来了大海贼时代！少年蒙奇·D·路飞为了成为海贼王，踏上了伟大的航路……',
    status: '连载中',
    updateTime: '2026-08-04',
    totalChapters: 1109,
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-011-1109', title: '第1109话 最终篇章', number: 1109, updateTime: '2026-08-04' },
      { id: 'ch-011-1108', title: '第1108话 四皇之战', number: 1108, updateTime: '2026-07-28' },
      { id: 'ch-011-1107', title: '第1107话 世界的真相', number: 1107, updateTime: '2026-07-21' },
      { id: 'ch-011-1106', title: '第1106话 路飞的决意', number: 1106, updateTime: '2026-07-14' },
      { id: 'ch-011-1105', title: '第1105话 古代兵器', number: 1105, updateTime: '2026-07-07' },
    ],
  },
  {
    id: 'comic-012',
    title: '天官赐福',
    author: '墨香铜臭 / STARember',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20cultivation%20manhua%20cover%2C%20a%20graceful%20immortal%20in%20flowing%20white%20and%20red%20robes%20with%20long%20dark%20hair%2C%20ancient%20Chinese%20architecture%20and%20cloud%20patterns%2C%20ethereal%20divine%20atmosphere%2C%20peach%20blossoms%2C%20elegant%20and%20romantic%2C%20clean%20illustration&width=400&height=560&seq=pipi-comic-012&orientation=portrait',
    category: 'cn',
    tags: ['古风', '奇幻', '仙侠'],
    rating: 9.5,
    description: '八百年前，谢怜贵为仙乐国太子，一朝飞升成为万人敬仰的武神。然而好景不长，他接连被贬两次，成为了三界笑柄。第三次飞升时，他意外破坏了各路人马的计划，还遇到了一个神秘的红衣少年。从此，一段跨越八百年的因缘被揭开了……',
    status: '连载中',
    updateTime: '2026-08-02',
    totalChapters: 98,
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'ch-012-98', title: '第98话 花城的心意', number: 98, updateTime: '2026-08-02' },
      { id: 'ch-012-97', title: '第97话 铜炉山', number: 97, updateTime: '2026-07-26' },
      { id: 'ch-012-96', title: '第96话 绝境逢生', number: 96, updateTime: '2026-07-19' },
      { id: 'ch-012-95', title: '第95话 黑水沉舟', number: 95, updateTime: '2026-07-12' },
      { id: 'ch-012-94', title: '第94话 风师娘娘', number: 94, updateTime: '2026-07-05' },
    ],
  },
];